import Typography from '@hellodarwin/core/lib/components/common/typography';
import styled from 'styled-components';
export const FavoriteCandidatesContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: fit-content;
  min-height: ${({ isSectionAccessible }) => isSectionAccessible ? 'none' : '240px'};
  row-gap: 24px;
  column-gap: 24px;

  filter: ${({ isSectionAccessible }) => isSectionAccessible ? 'none' : 'blur(4px)'};
  pointer-events: ${({ isSectionAccessible }) => isSectionAccessible ? 'auto' : 'none'};

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;
export const ChartContainer = styled.div `
  width: 100%;
  height: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: left;
  border-radius: 16px;
  padding: 16px;
`;
export const ParentContainer = styled.div `
  position: relative;
`;
export const ChartTitle = styled(Typography) `
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.colors.grey_2};
`;
export const AcceptedApplicationCount = styled(Typography) `
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.colors.grey_2};
`;
